import { IServiceEnablementResponse } from "@wingspanhq/benefits/dist/src/lib/interfaces";
import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../utils/serviceHelper";
import { getBenefitsService } from "../../services/benefits";

export const QUERY_BENEFITS_SERVICE = "QUERY_BENEFITS_SERVICE";

export const useBenefitsService = (
  queryConfig?: WSQueryConfig<IServiceEnablementResponse, WSServiceError>
) => {
  return useWSQuery(
    QUERY_BENEFITS_SERVICE,
    async () => {
      try {
        return await getBenefitsService();
      } catch {
        return { enabled: false } as IServiceEnablementResponse;
      }
    },
    queryConfig
  );
};
